export const createDateWithoutSeconds = (): Date => {
  const date = new Date();
  date.setSeconds(0, 0);
  return date;
};
